import { defineMessages } from 'react-intl';

import { showFlag } from 'src/redux/flags';

const messages = defineMessages({
  error: {
    id: 'frontbucket.repository.pullrequest.attachments.flag.update.error',
    description:
      'flag text when request to update attachments to a pull request fails',
    defaultMessage: 'Unable to update attachments. Please try again later.',
  },
  addError: {
    id: 'frontbucket.repository.pullrequest.attachments.flag.add.error',
    description:
      'flag text when request to add attachments to a pull request fails',
    defaultMessage: 'Unable to add attachments. Please try again later.',
  },
  addSuccess: {
    id: 'frontbucket.repository.pullrequest.attachments.flag.add.success',
    description:
      'flag text when request to add attachments to a pull request succeeds',
    defaultMessage: 'Successfully added attachment.',
  },
  removeSuccess: {
    id: 'frontbucket.repository.pullrequest.attachments.flag.remove.success',
    description:
      'flag text when request to remove attachments from a pull request succeeds',
    defaultMessage: 'Successfully removed attachment.',
  },
  removeError: {
    id: 'frontbucket.repository.pullrequest.attachments.flag.remove.error',
    description:
      'flag text when request to remove attachments from a pull request fails',
    defaultMessage: 'Unable to remove attachments. Please try again later.',
  },
});

export const updateErrorAction = showFlag({
  iconType: 'error',
  id: 'update-attachments-error',
  title: { msg: messages.error },
  autoDismiss: true,
});
export const addSuccessAction = showFlag({
  iconType: 'success',
  id: 'add-attachment-success',
  title: { msg: messages.addSuccess },
  autoDismiss: true,
});
export const removeSuccessAction = showFlag({
  iconType: 'success',
  id: 'delete-attachment-success',
  title: { msg: messages.removeSuccess },
  autoDismiss: true,
});
export const addErrorAction = showFlag({
  iconType: 'error',
  id: 'update-attachments-error-add',
  title: { msg: messages.addError },
  autoDismiss: true,
});
export const removeErrorAction = showFlag({
  iconType: 'error',
  id: 'update-attachments-error-remove',
  title: { msg: messages.removeError },
  autoDismiss: true,
});
